import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CountUp from './CountUp'

const ImpactWidget = ({ amount, description, currency_symbol }) =>
  <p className="impact-widget d-flex align-items-center p-1 p-lg-3 mb-0">
    <FontAwesomeIcon
      icon="home"
      size="2x"
      fixedWidth
      className="d-block ml-2 mr-1"
    />
    <span className="impact-widget-amount h1 d-block m-0 p-2 p-lg-3 fixed-width-numbers">
      <CountUp value={amount} prefix={currency_symbol} />
    </span>
    <span className="impact-widget-description d-block p-2">
      {description}
    </span>
  </p>

export default ImpactWidget
